import { ReactNode } from "react";
import styles from "./TopRowMain.module.css";

type TopRowMainProps = {
  children: ReactNode;
};

function TopRowMain({ children }: TopRowMainProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default TopRowMain;
